<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានអតិថិជន</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដ</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell><b>
							<span v-if="String(client.hash).length > 0">{{client.hash}}</span>
							<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.name).length > 0">{{client.name}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃខែឆ្នាំកំណើត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.dob).length > 0">{{client.dob}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ភេទ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.gender).length > 0">{{config.getGenderKhmer(client.gender)}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខអត្តសញ្ញាណប័ណ្ណ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.id_card).length > 0">{{client.id_card}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>

				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខទូរស័ព្ទ</md-table-cell>
						<md-table-cell style="width: 5px;">:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.phone).length > 0">{{client.phone}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>មុខរបរ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.occupation).length > 0">{{client.occupation}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>អាសយដ្ឋាន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.address).length > 0">{{client.address}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>កំណត់ចំណាំ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.note).length > 0">{{client.note}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃបង្កើត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<b><span v-if="String(client.created_date).length > 0">{{config.datelify(client.created_date)}}</span>
								<span v-else>N/A</span></b>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100" v-if="loanList.length > 0">
				<h3>ព័ត៌មានអំពីរំលោះ</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="loanList.length > 0">
					<md-table-row>
						<md-table-head>ល.រ</md-table-head>
						<md-table-head>លេខកូដ</md-table-head>
						<md-table-head>លេខឡូតិ៍</md-table-head>
						<md-table-head>ចំនួនខែបង់</md-table-head>
						<md-table-head>ការប្រាក់ និងប្រាក់ដើម</md-table-head>
						<md-table-head>ថ្ងៃបង់ប្រាក់បន្ទាប់</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(loan, index) in loanList">
						<md-table-cell>{{ index + 1 }}</md-table-cell>
						<md-table-cell><b>{{ loan.hash }}</b><br>{{ config.datelify(loan.created_date) }}</md-table-cell>
						<md-table-cell>{{loan.lot}}</md-table-cell>
						<md-table-cell><b>{{loan.total_paid_term - 1}} / {{loan.total_term - 1}}</b></md-table-cell>
						<md-table-cell>
							<b>{{config.moneylify(loan.total_paid_interest)}} / {{(config.moneylify(loan.total_interest))}}</b><br>
							<b>{{config.moneylify(loan.total_paid_principal)}} / {{(config.moneylify(loan.total_principal))}}</b></md-table-cell>
						<md-table-cell>
							<span v-if="loan.total_paid_term == loan.total_term || loan.status == 'fin'" class="active">មិនមាន</span>
							<span class="late"
								v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'ហួសកំណត់'">{{config.datelifyShort(loan.next_payment)}}</span>
							<span class="active"
								v-else-if="String(loan.next_payment).length >0">{{config.datelifyShort(loan.next_payment)}}
								({{config.timelify(loan.next_payment)}})</span>
						</md-table-cell>
						<md-table-cell>
							<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
							<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
						</md-table-cell>
						<md-table-cell>
							<router-link :to="'/loans/detail/' + loan.hash">
								<md-button class="md-just-icon md-simple md-success">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
								</md-button>
							</router-link>
							<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(loan.hash)">
								<md-icon>delete</md-icon>
								<md-tooltip md-direction="top">លុបការរំលោះនេះ</md-tooltip>
							</md-button>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getClient();
			window.scrollTo(0, 0)
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				client: {
					hash: "",
					name: "",
					phone: "",
					note: "",
					gender: "",
					created_date: ""
				},
				loanList: []

			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
				this.$http.post(this.config.api + "/admin/loan/search", {
					text: this.$route.params.hash, status: "", offset: 0
				}).then(data => {
					this.loanList = data.body.data;
				})

				this.$http.get(this.config.api + "/admin/loan/get/client/" + this.$route.params.hash).then(data => {
					this.loanList = data.body.data
				})
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Detail.vue